import { PaletteMode } from '@mui/material';
import { createContext } from 'react';

import { ThemeModePreference } from './themeModeStorage';

export interface ThemeModeContextValue {
  /** The user's chosen preference: 'light' | 'dark' | 'system'. */
  mode: ThemeModePreference;
  /** The effective mode after resolving 'system' against the OS preference. */
  resolvedMode: PaletteMode;
  /** Update the preference locally (also mirrored to localStorage). Backend
   * persistence is handled separately by the UserStore on user-initiated change. */
  setMode: (mode: ThemeModePreference) => void;
}

export const ThemeModeContext = createContext<ThemeModeContextValue | undefined>(
  undefined,
);
